/**
 * Configuración global de la API
 * Centraliza todas las configuraciones relacionadas con las APIs del sistema
 */

// Configuración base de las APIs
export const API_CONFIG = {
  // URLs base de los diferentes backends
  BACKOFFICE_BASE_URL: import.meta.env.VITE_RMI_API_URL_BACKOFFICE,  // Backend con autenticación
  GENERIC_BASE_URL: import.meta.env.VITE_RMI_API_URL_GENERIC,        // Backend sin autenticación (público)

  // Timeouts
  REQUEST_TIMEOUT: 30000, // 30 segundos

  // Paginación
  DEFAULT_PAGE_SIZE: 20,
  MAX_PAGE_SIZE: 100,

  // Reintentos
  DEFAULT_RETRY_COUNT: 2,
  MAX_RETRY_DELAY: 30000, // 30 segundos

  // Cache
  DEFAULT_STALE_TIME: 5 * 60 * 1000, // 5 minutos
  DEFAULT_GC_TIME: 10 * 60 * 1000, // 10 minutos
} as const;

// Configuración simplificada - las URLs se definen en src/common/consts/apiUrls.ts
// El httpClient detecta automáticamente qué backend usar según la URL completa

// Configuración de headers por defecto
export const DEFAULT_HEADERS = {
  "Content-Type": "application/json",
  Accept: "application/json",
} as const;

// Configuración de errores HTTP
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
  LOCKED: 423,
} as const;

// Mensajes de error por defecto
export const ERROR_MESSAGES = {
  NETWORK_ERROR: "Error de conexión. Verifica tu conexión a internet.",
  SERVER_ERROR: "Error interno del servidor. Por favor, intenta nuevamente.",
  UNAUTHORIZED: "No tienes permisos para realizar esta acción.",
  BAD_REQUEST: "Error en los parámetros de la solicitud.",
  NOT_FOUND: "El recurso solicitado no fue encontrado.",
  TIMEOUT: "La solicitud tardó demasiado tiempo. Intenta nuevamente.",
} as const;

// Las URLs se definen en src/common/consts/apiUrls.ts

// Configuración de React Query por defecto
export const QUERY_CONFIG = {
  defaultOptions: {
    queries: {
      staleTime: API_CONFIG.DEFAULT_STALE_TIME,
      gcTime: API_CONFIG.DEFAULT_GC_TIME,
      retry: API_CONFIG.DEFAULT_RETRY_COUNT,
      retryDelay: (attemptIndex: number) =>
        Math.min(1000 * 2 ** attemptIndex, API_CONFIG.MAX_RETRY_DELAY),
    },
  },
} as const;
